import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'app-quick-search',
    templateUrl: './quick-search.component.html',
    styleUrls: ['./quick-search.component.scss'],
    standalone: false
})
export class QuickSearchComponent implements OnInit, OnChanges {
  @Input() filterLookupResults = [];
  @Input() doingFilterLookup = false;
  @Input() labelKey = 'label';
  @Input() inputPlaceholder = 'Start typing the Taxpayer Name';
  @Output() doSearchEvent = new EventEmitter();
  @Output() selectResultEvent = new EventEmitter();

  public form: FormGroup;
  public selectedResult = null;

  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef) {
    this.form = this.fb.group({ filterTerm: '' });
  }

  ngOnInit() {
    this.form
      .get('filterTerm')
      .valueChanges.pipe(debounceTime(1000))
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (term: string) => {
          if (term) {
            this.doSearch();
          }
        },
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.cdr.detectChanges();
  }

  @HostListener('document:mousedown', ['$event'])
  closeDropdown(event: MouseEvent) {
    const idArray = ['quick-search-input', 'search-button', 'lookup-dropdown'];
    if (idArray.indexOf(event.target['id']) === -1) {
      this.closeLookUp();
    }
  }

  public doSearch() {
    if (!this.doingFilterLookup && this.filterTerm) {
      this.doSearchEvent.emit(this.form.get('filterTerm').value);
    }
  }

  public closeLookUp() {
    this.filterLookupResults = [];
    this.form.reset();
  }

  public selectLookupResult(lookupResult: any) {
    this.selectedResult = lookupResult;
    this.closeLookUp();
    this.selectResultEvent.emit(lookupResult);
    this.form.patchValue({ filterTerm: '' });
  }

  public resetInput() {
    this.selectLookupResult(null);
  }

  public get filterTerm() {
    return this.form.get('filterTerm').value;
  }
}
